/**
 * Allows the use of setTimeout within a promise then sequence.
 * No callback is executed.
 *
 * @param ms The milliseconds of delay
 * @param v
 * @returns {Promise<unknown>}
 */
export const promiseDelay = ( ms, v ) => {
	return new Promise( function( resolve ) {
		setTimeout( resolve.bind( null, v ), ms )
	} );
}

let delayTimer;

/**
 *
 * @param callback
 * @param delayMS
 */
export const delayCallback = ( callback, delayMS = 1000 ) => {

	clearTimeout( delayTimer );

	delayTimer = setTimeout( () => {
		if ( 'function' === typeof callback ) {
			callback();
		}
	}, delayMS );
}
